import axios from "axios";
import { API_BASE_URL } from "../environment";

export const createNewLoan = async (data) => {
  const res = await axios.post(`${API_BASE_URL}/common?table=loans`, data);
  return res.data;
};
export const getAllLoans = async (data) => {
  const res = await axios.get(
    `${API_BASE_URL}/common?table=plan&start_date=${data.start_date}&end_date=${data.end_date}`
  );
  return res.data;
};
export const getLoansById = async (id) => {
  const res = await axios.get(`${API_BASE_URL}/plans/${id}`);
  return res.data;
};
export const aggrementVerify = async (data) => {
  const res = await axios.post(`${API_BASE_URL}/auth/arrgeement_verify`, data);
  return res.data;
};
export const updateLoan = async (id, data) => {
  const res = await axios.patch(`${API_BASE_URL}/common?table=loans&id=${id}`,
    data
  );
  return res.data;
};